
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"122","height":"31","viewBox":"0 0 122 31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.43 0c8.523 0 15.431 6.908 15.431 15.43 0 8.523-6.908 15.431-15.43 15.431C6.908 30.861 0 23.953 0 15.431 0 6.908 6.908 0 15.43 0zm-1.78 7.43c-4.246 0-7.757 3.145-7.757 7.783s3.511 8.217 7.756 8.218c2.33 0 4.054-.872 5.204-2.273v1.837h4.118V7.431h-9.322zm.766 3.393c2.553 0 4.436 1.775 4.436 4.39 0 2.614-1.883 4.388-4.436 4.389-2.522 0-4.405-1.774-4.405-4.39 0-2.614 1.883-4.389 4.405-4.389zM121.787 23.01h-4.135v-1.844c-1.155 1.407-2.886 2.283-5.226 2.283-4.264 0-7.79-3.596-7.79-8.254 0-4.659 3.526-7.817 7.79-7.817h9.361V23.01zm-65.532 0H52.12v-1.845c-1.154 1.407-2.885 2.283-5.225 2.283-4.264 0-7.791-3.595-7.791-8.253 0-4.659 3.527-7.817 7.79-7.817h9.362V23.01zM75.56 6.94c4.713 0 8.496 3.596 8.496 8.255 0 4.658-3.784 8.253-8.496 8.253-4.713 0-8.464-3.595-8.464-8.253 0-4.658 3.751-8.254 8.464-8.254zM64.145 23.01h-4.136V.188h4.136V23.01zM91.102 9.13c.962-1.407 2.628-2.19 4.776-2.19 3.398 0 6.06 2.314 6.06 6.472v9.598h-4.136v-9.098c0-2.125-1.315-3.22-3.174-3.22-2.02 0-3.526 1.157-3.526 3.877v8.441h-4.136V1.125h4.136V9.13zm-43.44 1.656c-2.532 0-4.423 1.783-4.423 4.409 0 2.625 1.89 4.408 4.423 4.408 2.565 0 4.457-1.782 4.457-4.408 0-2.626-1.892-4.409-4.457-4.409zm65.533 0c-2.532 0-4.423 1.783-4.423 4.409s1.891 4.408 4.423 4.408c2.565 0 4.457-1.782 4.457-4.408 0-2.626-1.892-4.409-4.457-4.409zm-37.635.094c-2.437 0-4.328 1.782-4.328 4.315 0 2.532 1.892 4.314 4.328 4.314 2.468 0 4.36-1.782 4.36-4.314 0-2.533-1.892-4.315-4.36-4.315z","fill":"currentColor"}})])
          )
        }
      }
    